var render = function render(){var _vm=this,_c=_vm._self._c;return _c('modal',{attrs:{"title":_vm.$t('set_jobs.details'),"loading":_vm.loading},on:{"close_modal":_vm.close_modal},scopedSlots:_vm._u([{key:"content",fn:function(){return [_c('div',{staticClass:"log-content"},[_vm._v(_vm._s(_vm.text))])]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }